import { ALL_DRIVER_STATUS, DRIVER_VISIBLE_TIME, DRIVER_EVENTS} from "../constants";
import { getUTCDate } from "../../../../../components/dataGrid/gridUtilities";
import { isBefore, isSameDay } from "date-fns";
import { utcToZonedTime } from "date-fns-tz";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import { getPendingStopStatus } from "../../utils/utils";
import appConstants from "../../../../../appConstants";
import { getDriverStatus } from "./DriverStatus";

export const isDriverReadyForDispatch = (
  driverClockedInTime,
  isCompanyDriver
) => {
  return isCompanyDriver ? isDriverTimeBeforeCurrentDateAndTime(driverClockedInTime) : true;
};

export const isDriverTimeBeforeCurrentDateAndTime = (driverStartTime) => {
  const currentUTCDate = getUTCDate(new Date());
  if (driverStartTime) {
    const clockedInUTCDate = getUTCDate(driverStartTime);
    return (
      clockedInUTCDate &&
      isSameDay(clockedInUTCDate, currentUTCDate) &&
      isBefore(clockedInUTCDate, currentUTCDate)
    );
  }
  return false;
};


export const isWithinTime = (time, terminalOffset) => {
 return time &&  (timeDiffFromTerminal(time, terminalOffset ) <= DRIVER_VISIBLE_TIME);
};

// get time difference in minutes from call time to current terminal Time
export const timeDiffFromTerminal = (time, terminalOffset) => {
  const terminalCurrentTime = utcToZonedTime(new Date(), terminalOffset);
  const [timeHour, timeMinutes] = time.split(":").map(Number);
  const [currentHour, currentMinutes] = [
    terminalCurrentTime.getHours(),
    terminalCurrentTime.getMinutes(),
  ];
  const hourDiff = timeHour - currentHour;
  const minDiff = timeMinutes - currentMinutes;
  return hourDiff * 60 + minDiff;
}

export const getNotClockedInDriverStatus = (time, terminalOffset) => {
  if (!time) {
    return "";
  }
  const mins = timeDiffFromTerminal(time, terminalOffset);
  if (mins < 0) {
    return ALL_DRIVER_STATUS.LateBy
  } else {
    return ALL_DRIVER_STATUS.DueTime
  }
};

export const getNotClockedInDriverLabel = (time, terminalOffset) => {
  if (!time) {
    return "";
  }
  const mins = timeDiffFromTerminal(time, terminalOffset);
  if (mins < 0) {
    const absMins = Math.abs(mins);
    const [hours, minutes] = [
      Math.floor(absMins / 60)
        .toString()
        .padStart(2, "0"),
      Math.floor(absMins % 60)
        .toString()
        .padStart(2, "0"),
    ];
    const timeString = `${hours}:${minutes}`;
    return `Late by ${timeString} scheduled start ${time}`;
  } else {
    return `Due to start in ${mins} minutes`;
  }
};

export const getClockedInDriverStatusLabel = (driverClockedInTime, driverClockedInDept) => {
  const date = getUTCDate(new Date(driverClockedInTime));
  const clockedInStatus = `Clocked in at ${date.toTimeString().slice(0, 5)}`;
  return driverClockedInDept && driverClockedInDept.toUpperCase() === "DOCK" ? `${driverClockedInDept} - ${clockedInStatus}` : clockedInStatus ;
};

export const getActiveStop = (data) => {
  return data.stops.find((stop) => stop.stopId === data.currentStatus?.stopId);
};

export const renderTimeWithErrorIcon = (time, showError=false) => {
  return (
    
      <div className="dispatch-time">
        <div
          className={`dispatch-time-value ${
            showError ? "dispatch-time-value-error" : ""
          }`}
        >
          {time}
        </div>
        <div className="dispatch-time-icon-container">
          {showError ? (
            <ErrorOutlineIcon className="dispatch-time-icon"/>
          ) : (
            ""
          )}
        </div>
      </div>
  );
};

export const hasStopDelayed = (selectedStop) => {
  return (
    !selectedStop?.isStopCompleted &&
    getPendingStopStatus(selectedStop) === appConstants.STOP_STATUS.DELAYED
  );
}

export const getStopArrivalTime = (stopStatus, stopData) => {
  return stopStatus === DRIVER_EVENTS.ArrivedAtStop
    ? stopData?.actualArrivalTime
    : stopData?.plannedArrivalTime || stopData.arrivalTime;
};

export const getStopArrivalTimeForDriverGrid = (driverStatus, stopData) => {
  return driverStatus === DRIVER_EVENTS.ArrivedAtStop
    ? stopData?.departureTime //departureTime will contain plannedDepartureTime if arrived at stop
    : stopData?.plannedArrivalTime || stopData.arrivalTime;
};

export const getZoneValue = (params) => {
  if (Number(params.data.dispatchZone) === 0) {
    return "";
  }
  return params.data.dispatchZone;
};

export const getArrivedAtOrEnrouteStop = (props) => {
  const { driverStatus } = getDriverStatus(props, false);
  if (
    [DRIVER_EVENTS.ArrivedAtStop, DRIVER_EVENTS.EnrouteToStop].includes(
      driverStatus
    )
  ) {
    return getActiveStop(props.data);
  }
  return null;
};